module.exports = __webpack_public_path__ + "img/Index_button_icon.88ebd8cf.svg";